export class VehicleBrandModel {
    Id!: number;
    NameBrand!: string;
    IsAvailable!: boolean;

    constructor(payload: { [key: string]: any }) {
        Object.assign(this, payload);
    }

    static mapToVehicleBrandModels(brands: any[]): VehicleBrandModel[] {
        return brands.map((brand: VehicleBrandModel) => new VehicleBrandModel(brand));
    }
}
